import script from "./PathDesigner.vue?vue&type=script&lang=ts&setup=true"
export * from "./PathDesigner.vue?vue&type=script&lang=ts&setup=true"

import "./PathDesigner.vue?vue&type=style&index=0&id=778bdcdd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-778bdcdd"]])

export default __exports__